import { render, staticRenderFns } from "./accesorios.vue?vue&type=template&id=1150c8bc&"
import script from "./accesorios.vue?vue&type=script&lang=js&"
export * from "./accesorios.vue?vue&type=script&lang=js&"
import style0 from "./accesorios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports